import React, { useState, useEffect } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { Plans } from "./ProtectionPlans"; // Import Plans from ProtectionPlans.jsx
import './Plandetail.css';

const PlanDetail = () => {
    const { title } = useParams(); // Retrieve the plan title from the URL
    const location = useLocation();
    const navigate = useNavigate(); // Hook for programmatic navigation
    const { plan } = location.state || {}; // Retrieve passed plan data through state

    const [isLoading, setIsLoading] = useState(true);
    const [selectedItem, setSelectedItem] = useState(
        plan || Plans.find((item) => item.title.replace(/ /g, "-") === title)
    ); // Match the title with hyphens
    const [isAnimating, setIsAnimating] = useState(false); // Animation state

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsLoading(false); // Stop loading after 2 seconds
        }, 1000);
        return () => clearTimeout(timer); // Cleanup timer on component unmount
    }, []);

    const handleItemClick = (item) => {
        setIsAnimating(true); // Start animation
        setTimeout(() => {
            setSelectedItem(item); // Update the selected item
            navigate(`/protection-plans/${item.title.replace(/ /g, "-")}`, { state: { plan: item } }); // Update the path with hyphens
            setIsAnimating(false); // End animation after transition
        }, 500); // Match the duration of the animation
    };

    const buttonclick = () => {
        navigate('/contact');
    }

    if (!selectedItem) {
        return <h1 className="text-center mt-5">No data available for {title.replace(/-/g, " ")}</h1>; // Decode hyphens to spaces
    }

    return (
        <div className="boxed_wrapper ltr">
            {isLoading ? (
                // Preloader
                <div className="loader-wrap">
                    {isLoading && <div className="loader-wrap">
                        <div className="preloader">
                            <div className="preloader-close">close</div>
                            <div id="handle-preloader" className="handle-preloader">
                                <div className="animation-preloader">
                                    {/* <div className="spinner"></div> */}
                                    <div className="txt-loading">
                                        <img src="/assets/images/animation_logo.gif" alt="img" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}
                </div>
            ) : (
                // Main Content
                <>
                    {/* Include Header/Navbar */}
                    <Header />

                    <div>
                        {/* page-title */}
                        <section className="page-title">
                            <div
                                className="bg-layer"
                                style={{
                                    backgroundImage: `url("/assets/images/background/page-title.jpg")`,
                                }}
                            ></div>
                            <div className="line-grid-wrap">
                                <span className="line-grid-1"></span>
                                <span className="line-grid-2"></span>
                                <span className="line-grid-3"></span>
                                <span className="line-grid-4"></span>
                                <span className="line-grid-5"></span>
                            </div>
                            <div className="auto-container">
                                <div className="content-box">
                                    <h1 style={{ textAlign: "left" }}>
                                        {selectedItem.title.replace(/-/g, " ")}
                                    </h1>
                                    <ul className="bread-crumb clearfix">
                                        <li>
                                            <Link to="/">Home</Link>
                                        </li>
                                        <li>
                                            <Link to="/protection-plans">Protection Plans</Link>
                                        </li>
                                        <li>{selectedItem.title.replace(/-/g, " ")}</li>
                                    </ul>
                                </div>
                            </div>
                        </section>
                        {/* page-title end */}

                        {/* service-details */}
                        <section className="service-details pt_120 pb_120">
                            <div className="auto-container">
                                <div className="row clearfix">
                                    <div className="col-lg-3 col-md-12 col-sm-12 sidebar-side">
                                        <div className="service-sidebar">
                                            <div className="category-widget sidebar-widget">
                                                <ul className="category-list clearfix">
                                                    {Plans.map((item, index) => (
                                                        <li
                                                            key={index}
                                                            className={`list-group-item ${item.title === selectedItem.title ? "active-item" : ""}`}
                                                            onClick={() => handleItemClick(item)}
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            <img
                                                                src={item.icon}
                                                                alt={item.title}
                                                                style={{
                                                                    width: 20,
                                                                    marginRight: 10,
                                                                }}
                                                            />
                                                            {item.title}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                            <div className="contact-widget sidebar-widget">
                                                <div className="inner-box">
                                                    <div className="image-box">
                                                        <figure className="image">
                                                            <img
                                                                src="assets/images/resource/about-1.jpeg"
                                                                alt=""
                                                            />
                                                        </figure>
                                                    </div>
                                                    <div className="content-box">
                                                        <h3>
                                                            <span>Available</span> for any type of
                                                            Service
                                                        </h3>
                                                        <h2>We can help</h2>
                                                        <div className="btn-box ">
                                                                <button onClick={buttonclick}
                                                                    href="contact.html"
                                                                    className="theme-btn btn-one"
                                                                    
                                                            >
                                                                Contact Us
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-9 col-md-12 col-sm-12 content-side">
                                        <div
                                            className={`service-details-content ml_35 ${isAnimating ? "animate-item" : ""}`}
                                        >
                                            <div className="content-one">
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <img
                                                        src={selectedItem.icon}
                                                        alt={selectedItem.title || "Image"}
                                                        className="img-fluid rounded"
                                                        style={{
                                                            marginRight: "30px",
                                                            width: "50px",
                                                            height: "50px",
                                                        }} // Adjust size as needed
                                                    />
                                                    <h1>{selectedItem.title.replace(/-/g, " ")}</h1>
                                                </div>

                                                <p style={{ textAlign: "left" }}>
                                                    {selectedItem.description}
                                                </p>

                                                {/* Image Section */}
                                                <div className="text-center mb-4">
                                                    <img
                                                        src="https://d3g5ywftkpzr0e.cloudfront.net/wp-content/uploads/2023/07/13220529/Artificial-Intelligence-in-Indonesia-The-current-state-and-its-opportunities.jpeg"
                                                        alt={selectedItem.title || "Image"}
                                                        className="img-fluid rounded"
                                                        style={{
                                                            maxHeight: "300px",
                                                            objectFit: "cover",
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            {/* Other content */}
                                            <div className="content-two">
                                                <div className="row clearfix">
                                                    {/* Service Benefits */}
                                                    <div className="content-two mt-5">
                                                        <div className="row align-items-center">
                                                            <div className="col-lg-7 col-md-6 col-sm-12 content-column">
                                                                <div className="content-box">
                                                                    <h1
                                                                        style={{
                                                                            textAlign: "left",
                                                                        }}
                                                                    >
                                                                        Service Benefits
                                                                    </h1>
                                                                    <p style={{ textAlign: "left" }}>
                                                                        Lorem Ipsum is simply dummy
                                                                        text of the printing and
                                                                        typesetting industry. Lorem
                                                                        Ipsum has been the
                                                                        industry's standard dummy
                                                                        text ever since the 1500s,
                                                                        when an unknown printer took
                                                                        a galley of type and
                                                                        scrambled it to make a type
                                                                        specimen book.
                                                                    </p>
                                                                    <ul className="list-one clearfix">
                                                                        <li>
                                                                            Lorem Ipsum is simply
                                                                            dummy text
                                                                        </li>
                                                                        <li>
                                                                            Professional team do work
                                                                        </li>
                                                                        <li>
                                                                            Lorem Ipsum is simply
                                                                            dummy text
                                                                        </li>
                                                                        <li>
                                                                            Flexible and
                                                                            Cost-Effective
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-5 col-md-6 col-sm-12">
                                                                <div className="image-box">
                                                                    <figure className="image">
                                                                        <video
                                                                            controls
                                                                            className="img-fluid rounded w-100"
                                                                            style={{
                                                                                height: "400px",
                                                                            }}
                                                                        >
                                                                            <source
                                                                                src="assets/videos/sample-video.mp4"
                                                                                type="video/mp4"
                                                                            />
                                                                            Your browser does not
                                                                            support the video tag.
                                                                        </video>
                                                                    </figure>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        {/* service-details end */}

                        {/* Include Footer */}
                            <Footer />
                            <div className="scroll-to-top" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} style={{ cursor: 'pointer' }}>
                                <div>
                                    <div className="scroll-top-inner">
                                        <div className="scroll-bar">
                                            <div className="bar-inner"></div>
                                        </div>
                                        <div className="scroll-bar-text">Go To Top</div>
                                    </div>
                                </div>
                            </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default PlanDetail;
